import { gql } from '@apollo/client';

export const DELETE_MUSCLE_GROUP = gql`
    mutation deleteMuscleGroup($id: ID!, $ptId: ID!){
        deleteMuscleGroup(id: $id, ptId: $ptId)
    }
`;
